(function () {
  "use strict";
  if (!/^(www\.)?lionshopsrbija\.online$/i.test(window.location.hostname)) return;

  var config = window.LionBackpackGiftConfig || {};
  var backpackProducts = new Set(["15395890954470", "15395891020006", "15395891052774"]);
  var giftVariant = 67587916529894;
  var onBackpackPage = backpackProducts.has(String(config.pageProductId || ""));
  var nativeFetch = window.fetch.bind(window);
  var syncing = false, pendingTimer = null, submitting = false;

  function cartPath(input) {
    try {
      var raw = typeof input === "string" ? input : input.url;
      var url = new URL(raw, window.location.href);
      return url.origin === window.location.origin ? url.pathname : "";
    } catch (_) { return ""; }
  }

  async function getCart() {
    var response = await nativeFetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" });
    if (!response.ok) throw new Error("Cannot read cart: " + response.status);
    return response.json();
  }

  async function updateGift() {
    if (syncing || submitting) return false;
    syncing = true;
    try {
      var cart = await getCart();
      var desired = cart.items.reduce(function (total, item) {
        return total + (backpackProducts.has(String(item.product_id)) ? item.quantity : 0);
      }, 0);
      var linked = cart.items.filter(function (item) {
        return String(item.variant_id) === String(giftVariant) &&
          item.properties && item.properties._lion_bonus_tabla === "1";
      });
      var present = linked.reduce(function (total, item) { return total + item.quantity; }, 0);
      if (desired === present) return false;

      if (!linked.length && desired > 0) {
        var addResponse = await nativeFetch("/cart/add.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: giftVariant, quantity: desired, properties: { _lion_bonus_tabla: "1" } }] })
        });
        if (!addResponse.ok) throw new Error("Cannot add gift: " + addResponse.status);
      } else {
        var first = true;
        for (var i = 0; i < linked.length; i++) {
          var changeResponse = await nativeFetch("/cart/change.js", {
            method: "POST", credentials: "same-origin",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: linked[i].key, quantity: first ? desired : 0 })
          });
          if (!changeResponse.ok) throw new Error("Cannot update gift: " + changeResponse.status);
          first = false;
        }
      }

      if (window.location.pathname === "/cart") window.location.reload();
      return true;
    } catch (error) {
      console.error("Lion backpack LED gift sync:", error);
      return false;
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(updateGift, 500);
  }

  window.fetch = function () {
    var path = cartPath(arguments[0]);
    var result = nativeFetch.apply(null, arguments);
    if (/^\/cart\/(?:add|update|change|clear)\.js$/.test(path)) {
      return result.then(function (response) {
        if (response.ok) scheduleSync();
        return response;
      });
    }
    return result;
  };

  async function addBackpackWithGift(form, button, destination) {
    if (submitting) return;
    if (form.reportValidity && !form.reportValidity()) return;
    var formData = new FormData(form);
    var variantId = Number(formData.get("id"));
    var quantity = Number(formData.get("quantity") || 1);
    if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isInteger(quantity) || quantity < 1) {
      window.alert("Izaberite dostupnu varijantu ranca.");
      return;
    }
    submitting = true;
    if (button) button.disabled = true;
    try {
      var response = await nativeFetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [
            { id: variantId, quantity: quantity },
            { id: giftVariant, quantity: quantity, properties: { _lion_bonus_tabla: "1" } }
          ]
        })
      });
      if (!response.ok) throw new Error("Cannot add backpack with free gift: " + response.status);
      submitting = false;
      await updateGift();
      window.location.assign(destination);
    } catch (error) {
      console.error("Lion backpack gift:", error);
      submitting = false;
      if (button) button.disabled = false;
      window.alert("Ranac i gratis LED tabla nisu dodati zajedno. Molimo pokušajte ponovo.");
    }
  }

  if (onBackpackPage) {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !String(form.action).includes("/cart/add")) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addBackpackWithGift(form, event.submitter, "/cart");
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest("button[data-lion-direct-checkout]") : null;
      if (!button || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var form = document.getElementById(button.getAttribute("data-lion-direct-checkout"));
      if (form) addBackpackWithGift(form, button, "/checkout");
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
